
<template>
  <b-modal size="xl" ref="modal" @close="close" centered no-close-on-backdrop>
    <template #modal-header="{ close }">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div></div>
        <h5 class="text-centerfont-weight-bolder m-0">Company Name: {{ company.name }}</h5>

        <b-button size="sm" variant="none" class="btn-icon btn-circle btn-hover-dark" title="Close" @click="close"
          v-b-tooltip.hover>
          <i class="material-icons icon-xl">close</i>
        </b-button>
      </div>
    </template>

    <template #default v-if="fetching">
      <div class="d-flex align-items-center justify-content-center">
        Loading...
      </div>
    </template>
    <template #default v-else>
      <div class="d-flex flex-column justify-content-around">
        <div class="bill-details-container">
          <div class="d-flex flex-column">
            <MonthPicker v-model="selectedDate" @update:modelValue="handleDateUpdate" />
            <div class="d-flex align-items-center justify-content-start mt-5 ml-2">
              <b-form-checkbox v-model="due_from_now">
                Set invoice due date from now
              </b-form-checkbox>
            </div>
          </div>
          <BillDatePicker v-model="selectedIssueDate" @update:modelValue="handleIssueDateUpdate" />
        </div>
        <div class="d-flex flex-column justify-content-between p-2 align-items-center" style="gap: 2rem;">
          <b-form-input class="btn-pill font-weight-bold mr-2 w-50 mt-5" :disabled="disabled" v-model="invoice_ref" />
          <b-button class="btn-pill font-weight-bold mr-2 w-50 mt-5" variant="dark" @click="previewBillingFile('pdf')"
            :disabled="fileLoading">
            <span>Preview PDF</span>
          </b-button>
          <b-button class="btn-pill font-weight-bold mr-2 w-50" variant="dark" @click="previewBillingFile('xlsx')"
            :disabled="fileLoading">
            <span>Preview XLSX</span>
          </b-button>
          <b-button class="btn-pill font-weight-bold mr-2 w-50" variant="dark" @click="generateBillingInvoice" :disabled="true"
            >
            <span>Generate Invoice</span>
          </b-button>
        </div>
      </div>
          <pdf-viewer v-if="showPDF" id="pdf-modal" :allowRejection="false" :url="selected_file" :name="fileName"
            :forceExpansion="true" :payment-u-r-l="''" :is-thumbnail="false" :enableOverlayEffect="true" @expand="{}"
            @closePDF="closeAttachment">
          </pdf-viewer>
          <xlsx-viewer v-else-if="showXLSX" id="xlsx-modal" key="selected_xlsx" :url="selected_file" :name="fileName"
            @expand="{}" @closePDF="closeAttachment">
          </xlsx-viewer>
    </template>
  </b-modal>
</template>

<script>
import AnalyticsService from "@/services/analytics.service";
import CompaniesService from "@/services/companies.service";
import EnumeratesService from "@/services/enumerates.service";

import pdfViewer from "@/components/pdfViewer.vue";
import xlsxViewer from "@/components/xlsxViewer.vue";
import MonthPicker from "./monthPicker.vue";
import BillDatePicker from "./billDatePicker.vue";
import { DateTime } from 'luxon'


import BillingService from "@/services/billing.service";

export default {
  name: "Billing",
  components: {
    pdfViewer,
    xlsxViewer,
    MonthPicker,
    BillDatePicker
  },
  data() {
    return {
      selected_file: null,
      showPDF: null,
      showXLSX: null,
      fileLoading: false,
      env: process.env.NODE_ENV,
      API_URL: process.env.VUE_APP_API_URL,
      error: null,
      fetching: false,
      company: {},
      fileName: "",
      invoice_ref: '',
      selectedDate: {
        date: DateTime.now().startOf('month'),
        monthNumber: null,
        year: null,
        startISO: '',
        endISO: '',
        startDate: '',
        endDate: ''
      },
      selectedIssueDate:  DateTime.now().startOf('month').toFormat('yyyy-MM-dd'),
      due_from_now: true,
    };
  },
  methods: {
    handleDateUpdate(dateObject) {
      this.selectedDate = dateObject
    },
    handleIssueDateUpdate(dateObject) {
      this.selectedIssueDate = dateObject
    },
    async fetch(id) {
      this.fetching = true;

      CompaniesService.get(id)
        .then(async ({ data }) => {
          this.company = data;

          const country_data = await EnumeratesService.countries();

          if (country_data?.data?.length) {
            const rec = country_data.data.find(
              (each) => each.id === data?.country
            );
            if (rec?.name) this.company["country"] = rec?.name;
          }

          const currency_data = await EnumeratesService.currencies();

          if (currency_data?.data?.length) {
            const rec = currency_data.data.find(
              (each) => each.id === data?.base_currency
            );
            if (rec?.name) this.company["base_currency"] = rec?.name;
          }
        })
        .catch(({ message }) => {
          this.error = message;
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    async downloadFile(url, name) {
      await fetch(this.getURL(url), {method: 'GET'})
      .then(res => {
        return res.blob();
      })
      .then(blob => {
        saveAs(blob, name);
      })
      .catch(err => {
        console.error('err: ', err);
      });
    },
    open(business) {
      this.error = null;
      this.fetching = false;
      this.company = business;
      this.$refs["modal"].show();
    },
    getURL(halfUrl) {
      if (this.env === 'development') {
        return this.API_URL + halfUrl;
      }
      else {
        return halfUrl;
      }
    },
    async getBillingInvoiceReference() {
      const {data} = await BillingService.getBillingInvoiceReference(this.company.id)
      this.invoice_ref = data.data.invoice_ref_num
    },
    previewBillingFile(format){
      let payload =  {
        "business_id": this.company.id,
        "start_date": this.selectedDate.startDate,
        "end_date": this.selectedDate.endDate,
        "format": format,
        "generate_billing_invoice": false,
        "invoice_ref": this.invoice_ref,
        "bill_inv_date": this.selectedIssueDate,
        "due_from_now": this.due_from_now
      }
      this.fileLoading = true
      if(!this.invoice_ref) {
        this.getBillingInvoiceReference()
      }
      BillingService.previewBillingFile(payload)
        .then(({data}) => {
          this.selected_file =  window.URL.createObjectURL(data);
          this.fileName = `Invoice Kema ${this.invoice_ref}`;
          this.fileLoading = false;
          if (payload['format']=='pdf') this.showPDF = true
          else this.showXLSX = true
        })
        .finally((error) => {
          this.fileLoading = false;
        })
    },
    generateBillingInvoice() {
      let payload = {
        "business_id": this.company.id,
        "start_date": this.selectedDate.startDate,
        "end_date": this.selectedDate.endDate,
        'format': null,
        'generate_billing_invoice': true,
        'invoice_ref': this.invoice_ref,
        'due_from_now': this.due_from_now
      }
      this.fileLoading = true;
      BillingService.generateBillingInvoice(payload)
        .then(({data}) => {
          alert(`Invoice ${data.data.reference_number} generated`);
          if (Array.isArray(data.data.attachments_urls)) {
            data.data.attachments_urls.forEach(attachmentUrl => {
              let name = "";
              if (String(attachmentUrl).endsWith("pdf")) {
                name = `${data.data.reference_number}.pdf`;
              } else if (String(attachmentUrl).endsWith("xlsx")) {
                name = `${data.data.reference_number}_Itemized.xlsx`;
              }
              this.downloadFile(attachmentUrl, name);
            });
          } else {
            console.warn("No attachments found.");
          }
        })
        .catch((error) => {
          console.error("Error generating billing invoice:", error);
        })
        .finally(() => {
          this.fileLoading = false;
        });
    },
    close() {
      this.$refs['modal'].hide()
    },
    closeAttachment(){
      this.selected_file = null;
      this.showPDF = false;
      this.showXLSX = false;
    },
  },
  computed: {
    disabled() {
      return this.sending;
    },
    variants() {
      return {
        show: this.error,
        "alert-light-danger": this.error,
      };
    },
  },

  watch: {
    company(newval) {
      if (newval.id) {
        this.fetching = true;
        AnalyticsService.get('merchants', { "id": this.company.id })
          .then(({ data }) => {
            this.analytics = data.current;
          })
          .catch((err) => console.log(err))
          .finally(() => {
            this.fetching = false;
          });
      }
    },
  },
};
</script>

<style scoped >
.bill-details-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 380px;
  border: 1px solid #edece9;
  width: 100%;
  padding: 0rem 1rem 1rem 1rem;
  box-shadow: none;
  font-family: "Quicksand-Medium";
}
</style>

